import { apiClient } from '../client';
import { API_CONFIG } from '../config';

export interface BusinessAccount {
  id: string;
  business_account_id: string;
  name: string;
  phone_number: string;
  phone_number_id: string;
  access_token_encrypted: string;
  is_active: boolean;
  quality_rating?: string;
  connection_type?: string | null;
  created_at: string;
  updated_at: string;
}

export interface CreateBusinessAccountData {
  name: string;
  phone_number: string;
  phone_number_id: string;
  business_account_id: string;
  access_token_encrypted: string;
}

export interface UpdateBusinessAccountData {
  name?: string;
  phone_number?: string;
  phone_number_id?: string;
  access_token_encrypted?: string;
  is_active?: boolean;
}

export interface BusinessAccountFilters {
  is_active?: boolean;
  business_account_id?: string;
}

export const businessAccountsApi = {
  // Get all business accounts
  async getAll(filters?: BusinessAccountFilters) {
    const params = new URLSearchParams();
    if (filters?.is_active !== undefined) {
      params.append('is_active', filters.is_active.toString());
    }
    if (filters?.business_account_id) {
      params.append('business_account_id', filters.business_account_id);
    }

    const queryString = params.toString();
    const url = queryString ? `/business-accounts?${queryString}` : '/business-accounts';
    
    return apiClient.get<BusinessAccount[]>(url);
  },

  // Get business account by ID
  async getById(id: string) {
    return apiClient.get<BusinessAccount>(`/business-accounts/${id}`);
  },

  // Create new business account
  async create(data: CreateBusinessAccountData) {
    return apiClient.post<BusinessAccount>('/business-accounts', data);
  },

  // Update business account
  async update(id: string, data: UpdateBusinessAccountData) {
    return apiClient.put<BusinessAccount>(`/business-accounts/${id}`, data);
  },

  // Delete business account
  async delete(id: string) {
    return apiClient.delete(`/business-accounts/${id}`);
  },

  // Update the per-BA lead form layout. `layout` is the full LeadFormLayout
  // object OR null to reset to baseline (the backend wipes the column on null).
  async updateLeadFormLayout(id: string, layout: unknown | null) {
    return apiClient.put<BusinessAccount>(`/business-accounts/${id}/lead-form-layout`, {
      lead_form_layout: layout,
    });
  }
};
